/* 카드 위시 하트(.theme-wish-btn)는 테마가 서버에서 미리 그리고, 앱(Swym)이 페이지를 한 번
   훑으며 클릭 핸들러·담김 상태를 붙인다(swym-loaded). 앱은 자기 버튼은 새 카드에도 다시
   붙이지만, 테마가 그린 버튼은 처음 훑을 때 있던 것만 본다. 그래서 랭킹 페이지의 재정렬,
   홈 슬라이더의 뒤늦은 삽입, 지연 렌더 섹션처럼 카드가 나중에 끼워지면 그 하트는 보이기만
   하고 눌리지 않는 채로 남는다 — 앱이 먼저 훑고 지나갔을 때만 생겨서 간헐적으로 보인다.

   새로 끼워진 하트를 보면 앱의 공식 재초기화 API 를 한 번 부른다. 인자는 컨테이너 하나를
   querySelector 로 찾는 셀렉터라 'body' 로 넓게 준다(실측: 미초기화 5개 → 0개, 첫 호출
   16.6ms · 재호출 4.9ms, 이미 초기화된 버튼엔 툴팁·핸들러가 겹치지 않는다).
   앱이 아직 안 떴으면(window._swat 없음) 아무것도 하지 않는다 — 그때는 앱의 첫 훑기가
   지금 문서에 있는 하트를 전부 맡는다. */
(function () {
  if (typeof MutationObserver !== 'function') return;

  var SELECTOR = '.theme-wish-btn';
  var PENDING = SELECTOR + ':not(.swym-loaded)';
  var scheduled = false;

  function initPendingButtons() {
    scheduled = false;
    var swat = window._swat;
    if (!swat || typeof swat.initializeActionButtons !== 'function') return;
    if (!document.querySelector(PENDING)) return;
    try {
      swat.initializeActionButtons('body');
    } catch (e) {
      /* 앱 쪽 오류는 하트 하나의 문제로 끝나야 한다 — 페이지 스크립트를 멈추지 않는다 */
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(initPendingButtons, { timeout: 1000 });
    } else {
      setTimeout(initPendingButtons, 200);
    }
  }

  function containsButton(node) {
    if (node.nodeType !== 1) return false;
    if (node.matches(SELECTOR)) return true;
    return !!(node.firstElementChild && node.querySelector(SELECTOR));
  }

  var observer = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i += 1) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j += 1) {
        if (containsButton(added[j])) {
          schedule();
          return;
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
